module.exports = __webpack_public_path__ + "img/q.209e70ed.png";